import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getAllMembers = async (languageId) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Members`,
      {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      }
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getAllDirectors = async (languageId) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Directors`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getMembersByName = async (languageId, name) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Members?name=${name}`,
      {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      }
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getMembersById = async (languageId, id) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Members/${id}`,
      {
        headers: {
          "ngrok-skip-browser-warning": true,
          UseAgent: "my-browser",
        },
      }
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getAccess = async () => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/AccessManager/v2`
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const getAllModality = async (languageId, listInactive) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Modality`,
      {
        params: {
          listInactive,
        },
      }
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getAllMembersByCommitteeId = async (languageId) => {
  try {
    const { data } = await axios
      .get
      // `${API_BACKEND_HOST}${languageId}/v1/Modality`
      ();
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getAllThemes = async (languageId) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/themes`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const finalDeliberations = [
  {
    id: "A",
    name: "Aprovado, pelos membros presentes com direito a voto, conforme material suporte / formulário de deliberação",
  },
  { id: "R", name: "Reprovado" },
  { id: "AR", name: "Aprovado com ressalva, pelos membros presentes com direito a voto" },
  {
    id: "ARB",
    name: "Aprovado Round Robin, pelos membros com direito a voto, conforme material suporte / formulário de deliberação",
  },
  { id: "NA", name: "N/A" },
];

export const finalDeliberationOptions = {
  pt: [
    { id: "A", name: "Aprovado, pelos membros presentes com direito a voto, conforme material suporte / formulário de deliberação" },
    { id: "R", name: "Reprovado" },
    { id: "AR", name: "Aprovado com ressalva, pelos membros presentes com direito a voto" },
    { id: "ARB", name: "Aprovado Round Robin, pelos membros com direito a voto, conforme material suporte / formulário de deliberação" },
    { id: "NA", name: "N/A" },
  ],
  en: [
    {
      id: "A",
      name: "Approved by the members present according to support material / deliberation form",
    },
    { id: "R", name: "Reproved" },
    { id: "AR", name: "Approved with caveats" },
    {
      id: "ARB",
      name: "Round Robin approved according to supporting material/deliberation form",
    },
    { id: "NA", name: "N/A" },
  ],
  es: [
    {
      id: "A",
      name: "Aprobado por los miembros presentes según material de apoyo / formulario de deliberación",
    },
    { id: "R", name: "Desaprobado" },
    { id: "AR", name: "Aprobado con reservas" },
    {
      id: "ARB",
      name: "Round Robin aprobado de acuerdo con el material de apoyo/formulario de deliberación",
    },
    { id: "NA", name: "N/A" },
  ],
};
